export default [
  {
    id: "public",
    name: "resources.bookmakers.visibility.public",
  },
  {
    id: "private",
    name: "resources.bookmakers.visibility.private",
  },
];
